/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
// Caminho direto: o plugin de importação sob demanda do Element UI
// quebra se o pacote inteiro e os componentes avulsos entram juntos.
import Element from 'element-ui/lib/element-ui.common'
import 'element-ui/lib/theme-chalk/index.css'
import GAuth from 'vue-google-oauth2'
import Moment from 'moment'

import Multiselect from 'vue-multiselect'
import DashboardPlugin from './plugins/dashboard-plugin'
import App from './App.vue'
import store from './store'
import { janooApi, knowledgeApi, cakeApi } from './services/config'

// router setup
import router from './routes/router'

const gauthOption = {
  clientId:
    '174442932190-hp5615v4fdf8utd8m3e6njpe67tr8i9t.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account',
}

Vue.use(DashboardPlugin)
Vue.use(Moment.locale('pt-br'))
Vue.use(GAuth, gauthOption)
Vue.use(Element)

Vue.component('multiselect', Multiselect)

window.janooApi = janooApi
window.knowledgeApi = knowledgeApi
window.cakeApi = cakeApi

import httpInterceptorNode from './helpers/httpInterceptorNode'
httpInterceptorNode()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(App),
  router,
  store,
})
